import { Tooltip } from "antd";
import "./style.scss"
import { logout, notification } from "../../../../assets/images";
import { useSelector} from "react-redux";
const Header = () => {
    const title = useSelector((state) => state.headerTitle.title);

    const handleLogout = () => {
        try {
            sessionStorage.removeItem("_ac");
            sessionStorage.removeItem("currentMenu");
            window.location.href = '/';
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };
    return <>
        <div className="header">
            <div style={{ paddingLeft: "20px" }}>
                <h1 className="header__title">{title}</h1>
            </div>
            <div className="header-details">
                <div>
                    <Tooltip title="Log Out">
                        <img src={logout} alt="" style={{ cursor: "pointer" }} onClick={handleLogout} />
                    </Tooltip>
                </div>
                <div>
                    <Tooltip title="Notification" placement="left">
                        <img src={notification} alt="" />
                    </Tooltip>
                </div>
            </div>
        </div>
    </>
};
export default Header